<template>
  <div class="footer-impressao">
    <div>
      Copyright {{ new Date().getFullYear() }} ® - Todos os Direitos Reservados a Econet Editora
      Empresarial
    </div>
    <div>
      <img class="logo-empresa" src="@/assets/images/econet_mini_logo.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterImpressao"
};
</script>

<style lang="scss" scoped>
.footer-impressao {
  display: none;
  padding: 7px 5px 0 5px;
  border-top: 1px solid #aaa;
  margin: 5px 10px 0 7px;
  align-items: center;
  justify-content: space-between;
}
@media only print {
  .footer-impressao {
    display: flex;
  }
}
</style>
